import { Login } from "@kalyzee/kast-web-sdk/adapted-web-components";
import { AuthenticationMethod, AuthenticationResult } from "@kalyzee/kast-web-sdk/web-components";

import { useEffect, useState } from "react";
import { toastError } from "../../../helpers/toast";
import "./login.css";
import styles from "./login.module.css";

import { ReactIcons } from "@kalyzee/kalyzee-ui";
import { useAuthContext } from "@kalyzee/kast-web-sdk";
import { MasterUI } from "../../../components/common/MasterUI";
import { MainClockRenderer } from "../../../components/renderers/mainClock";
import { useSdkContext } from "../../../contexts/sdk/context";

export interface LoginPageProps { }

const LoginPage = ({ }: LoginPageProps) => {
  const { setTokens } = useAuthContext();

  const [oAuthError, setOAuthError] = useState<boolean>();

  const sdkCtx = useSdkContext();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('backend_error');
    if (error) {
      setOAuthError(true);
      console.error('Error while authenticating with Google: ', error);
    }
  }, []);

  const onResult = async (result: AuthenticationResult) => {
    if (result.success) {
      const tokens = result.tokens;
      if (tokens?.token) {
        setTokens({ token: tokens.token, refreshToken: tokens.refreshToken });
      }
    } else {
      toastError("Identifiants incorrectes")
    }
  };

  const renderAuth = () => {
    return (
      <Login
        className={styles.login}
        sdk={sdkCtx.client}
        logo={null}
        methods={[AuthenticationMethod.Local, AuthenticationMethod.Google]}
        oAuthRedirectUri={window.origin}
        onResult={onResult}
        googleAuthentificationProps={oAuthError ? {
          error: 'Une erreur est survenue',
        } : undefined}
        localAuthentificationProps={{
          placeholderEmail: 'Email',
          placeholderPassword: 'Mot de passe'
        }}
      />
    );
  }

  const renderDateAndTime = () => {
    return (
      <MainClockRenderer
        render={date => {
          let stringDate = date.toLocaleDateString(undefined, {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          });
          stringDate = stringDate.charAt(0).toUpperCase() + stringDate.slice(1);
          const stringTime = date.toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          });
          return (
            <div className={styles.dateTime}>
              <span className={styles.date}>{stringDate}</span>
              <span className={styles.time}>{stringTime}</span>
            </div>
          );
        }}
      />
    )
  };

  return (
    <MasterUI>
      <div className={styles.backgroundHome}>
        <div className={styles.headerHome}>
          <ReactIcons.LogoFullAnimated
            style={{ width: 300 }}
          />
          <span className={styles.logo}>
            KALYZÉE
            <span className={styles.logoMeet}>
              {"Connect"}
            </span>
          </span>
        </div>
        <div className={styles.mainHome}>
          {renderAuth()}
        </div>
        <div className={styles.footerHome}>
          {renderDateAndTime()}
        </div>
      </div>
    </MasterUI>
  );
};

export default LoginPage;
